// this is an autogenerated file from App/Account/Topbar/Inbox/Content/mutation-mark-all-notifications-read.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Topbar_Inbox_Content($user_id: uuid!) {
  update_notifications_users(
    where: { user_id: { _eq: $user_id } }
    _set: { status: READ }
  ) {
    returning {
      id
    }
  }
}

`